<div class="modal-wrapper">
  <div class="rendez-vous-date-summer">
    <p>{{textDate}}</p>
    <button (click)="handleShowCalend()" class="date-edit-pen"></button>
  </div>
  <div *ngIf="showCalend">
    <div class="header">
      <p class="current-date">{{ monthYear }}</p>
      <div class="icons">
        <button id="prev" (click)="goToPrevMonth()">
        </button>
        <button id="next" (click)="goToNextMonth()">
        </button>
      </div>
    </div>
    <div class="calendar">
      <ul class="weeks">
        <li *ngFor="let day of daysOfWeek">
          <div class="week-container">    {{ day }} </div>

        </li>
      </ul>
      <ul class="days" *ngFor="let week of weeks">
        <li *ngFor="let day of week" [class]="{'disabled' : isPast(day.date)}"   (click)="onDateClick(day)">
          <div class="day-container"
            [ngClass]="{'green': day.color === 'green', 'blue': day.color == 'blue', 'fixed': day.color === 'green'}">
            {{ day.number !== '' ? day.number : ''}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>